import { InputMask } from 'primereact/inputmask';
import { classNames } from "primereact/utils"
import { Controller } from "react-hook-form"

interface IInputMask {
    label?: string,
    name: string,
    mask?: string
    control: any,
    error?: string,
    required?: boolean,
    disabled?: boolean,
    placeholder?: string,
    column?: number,
    min?: number,
    max?: number,
}

export const JVInputMask = (props: IInputMask) => {
    const className = props.column ? `field col-12 md:col-${12 / props.column}` : "field col-12 md:col-6";
    return (
        <div className={className}>
            {props.label && <label htmlFor={props.name}>{props.label}{props.required && <span style={{ color: 'red' }}>*</span>}</label>}
            <Controller name={props.name} control={props.control} render={({ field, fieldState }) => (
                <InputMask {...field}
                    disabled={props.disabled} mask={props.mask}
                    placeholder={props.placeholder} min={props.min} max={props.max}
                    className={classNames({ 'p-invalid': fieldState.invalid })} />
            )} />
            <small className="p-error" >{props.error}</small>
        </div>
    );
}